import { __exports as i } from "./index116.js";
import { __require as h } from "./index115.js";
import { __require as l } from "./index117.js";
import { __require as m } from "./index111.js";
import { __require as y } from "./index85.js";
var d;
function I() {
  if (d) return i;
  d = 1;
  var a = i && i.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(i, "__esModule", { value: !0 }), i.Group = void 0;
  var f = a(h()), c = a(l()), _ = a(m()), o = y();
  function p(r, t) {
    o.Facade.call(this, r, t);
  }
  i.Group = p, f.default(p, o.Facade);
  var e = p.prototype;
  return e.action = function() {
    return "group";
  }, e.type = e.action, e.groupId = o.Facade.field("groupId"), e.created = function() {
    var r = this.proxy("traits.createdAt") || this.proxy("traits.created") || this.proxy("properties.createdAt") || this.proxy("properties.created");
    if (r)
      return _.default(r);
  }, e.email = function() {
    var r = this.proxy("traits.email");
    if (r)
      return r;
    var t = this.groupId();
    if (c.default(t))
      return t;
  }, e.traits = function(r) {
    var t = this.properties(), n = this.groupId();
    r = r || {}, n && (t.id = n);
    for (var u in r)
      if (Object.prototype.hasOwnProperty.call(r, u)) {
        var s = this[u] == null ? this.proxy("traits." + u) : this[u]();
        if (s == null)
          continue;
        t[r[u]] = s, delete t[u];
      }
    return t;
  }, e.name = o.Facade.proxy("traits.name"), e.industry = o.Facade.proxy("traits.industry"), e.employees = o.Facade.proxy("traits.employees"), e.properties = function() {
    return this.field("traits") || this.field("properties") || {};
  }, i;
}
export {
  I as __require
};
//# sourceMappingURL=index87.js.map
